import { AppPagePaths } from "App/routes/paths";
import { audiencePathResources } from "Pages/audience/Pages/audiencePaths";

export function useAudiencePathing() {
    return {
        contactsBasePath: `${AppPagePaths.audience}/${audiencePathResources.contacts}`,
        segmentsBasePath: `${AppPagePaths.audience}/${audiencePathResources.segments}`,
    };
}
